import { urlCollectionAuctionNfts, urlFetchAuctions, urlNFT } from '../constants/restURL';
import Axios from 'axios';
import {
    AUCTIONS_FETCH_ERROR,
    AUCTIONS_FETCH_IN_PROGRESS,
    AUCTIONS_FETCH_SUCCESS,
    FETCH_AUCTION_COLLECTION_NFT_S_SUCCESS,
    FETCH_AUCTIONS_COLLECTION_NFT_S_ERROR,
    FETCH_AUCTIONS_COLLECTION_NFT_S_IN_PROGRESS,
    FETCH_NFT_ERROR,
    FETCH_NFT_IN_PROGRESS,
    FETCH_NFT_SUCCESS,
} from '../constants/auctions';
import { handleErrorMessage } from '../utils/errorMessages';

const fetchAuctionsInProgress = () => {
    return {
        type: AUCTIONS_FETCH_IN_PROGRESS,
    };
};

const fetchAuctionsSuccess = (value, skip, limit, search, total) => {
    return {
        type: AUCTIONS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchAuctionsError = (message) => {
    return {
        type: AUCTIONS_FETCH_ERROR,
        message,
    };
};

export const fetchAuctions = (address, skip, limit, search, priceDenom, minPrice, maxPrice, cb) => (dispatch) => {
    dispatch(fetchAuctionsInProgress());

    const url = urlFetchAuctions(address, skip, limit, search, priceDenom, minPrice, maxPrice);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchAuctionsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchAuctionsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchCollectionAuctionsInProgress = () => {
    return {
        type: FETCH_AUCTIONS_COLLECTION_NFT_S_IN_PROGRESS,
    };
};

const fetchCollectionAuctionsSuccess = (value, skip, limit, total) => {
    return {
        type: FETCH_AUCTION_COLLECTION_NFT_S_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchCollectionAuctionsError = (message) => {
    return {
        type: FETCH_AUCTIONS_COLLECTION_NFT_S_ERROR,
        message,
    };
};

export const fetchCollectionAuctions = (id, address, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchCollectionAuctionsInProgress());

    const url = urlCollectionAuctionNfts(id, address, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchCollectionAuctionsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchCollectionAuctionsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchNFTInProgress = () => {
    return {
        type: FETCH_NFT_IN_PROGRESS,
    };
};

const fetchNFTSuccess = (value) => {
    return {
        type: FETCH_NFT_SUCCESS,
        value,
    };
};

const fetchNFTError = (message) => {
    return {
        type: FETCH_NFT_ERROR,
        message,
    };
};

export const fetchNFT = (collectionID, id, cb) => (dispatch) => {
    dispatch(fetchNFTInProgress());

    const url = urlNFT(collectionID, id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchNFTSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNFTError(message));

            if (cb) {
                cb(null);
            }
        });
};
